export default {
	save: "Enregistrer",
	cancel: "Annuler",
	ok: "OK",
	change: "Modifier",
};
